<template>
    <div>
        <brand-write-link v-for="writeLayout in writeLayouts" :key="`brand${writeLayout}`"
                           :writeLayout="writeLayout" :brandData="brandData"></brand-write-link>
    </div>
</template>

<script>
import brandUtil from "@/components/brand/brandUtil";
import BrandWriteLink from "@/components/brand/link/BrandWriteLink";
import BrandValidator from "@/mixins/validators/BrandValidator";
import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/mixins/event-bus";
import util from "@/mixins/util";
import ApiFileUpload from "@/mixins/ApiFileUpload";
import DeleteClass from "@/mixins/deleteClass";

import {getTokenObj} from "@/mixins/Auth";

export default {
    name: "BrandWriteComponent",
    mixins: [alertMixins, brandUtil, BrandValidator, ApiFileUpload],
    components: {BrandWriteLink},
    inject: [],
    provide() {
        return {
            brandWriteSetData: this.setData,
        }
    },
    props: {
        brandType: {},
        brandKey: {default: 0},
        defaultFilter: {
            default: () => {
            }
        },
    },
    data() {
        return {
            getFunc: '',
            detailApiParamSet: {},
            getCategoryFunc: '',
            isCategory: true,
            writeFunc: '',
            writeLayouts: [],
            writeApiParamSet: {},
            brandData: {},
            isRunning: false,
            parsingData: {},
            fileInfo: [],
            directUrl: '',
            directType: '',
            writeSuccessType: 1,
            writeFailTypes: {},
            writeFailMsg: '',
            fileUploadFailMsg: '',
            keyName: '',

            isUpdateSurvey: false,
            allSetData: false,

            deleteFunc: '',
            deleteApiParamsSet: {},
            deleteSuccessType: 1,
            deleteFailTypes: {},
            deleteKeyName: '',

            DeleteClass: null,

            deleteFiles:[]
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.initFilterConfig();
        if (this.brandKey === 0) {
            this.initTemplateConfig();
        } else {
            this.getBrand();
        }
    },
    mounted() {
        EventBus.$on('writeBrand', this.writeBrand);
        EventBus.$on('deleteBrand', this.runDelete);
        EventBus.$on('writeGetBrand', this.getBrand);
    },
    beforeDestroy() {
        EventBus.$off('writeBrand')
        EventBus.$off('deleteBrand');
        EventBus.$off('writeGetBrand');
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(type, value) {
            this[type] = value;
        },

        initTemplateConfig() {
            let config = this.returnBrandConfig(this.brandType);
            this.writeLayouts = config.writeLayouts;
        },

        initFilterConfig() {
            let config = this.returnBrandConfig(this.brandType);
            this.getFunc = config.getFunc;
            this.writeFunc = config.writeFunc;
            this.writeApiParamSet = config.writeApiParamSet;
            this.writeSuccessType = config.writeSuccessType;
            this.writeFailTypes = config.writeFailTypes;
            this.writeFailMsg = config.writeFailMsg;

            this.parsingData = config.parsingData;
            this.detailApiParamSet = config.detailApiParamSet;
            this.fileInfo = config.fileInfo;
            this.keyName = config.keyName ?? 'b_idx';
            this.directUrl = config.directUrl;
            this.directType = config.directType;

            this.isUpdateSurvey = config.isUpdateSurvey;
            this.allSetData = config.allSetData;

            this.deleteFunc = config.deleteFunc;
            this.deleteSuccessType = config.deleteSuccessType;
            this.deleteFailTypes = config.deleteFailTypes;

            this.newDeleteClass();
        },

        getBrand() {
            let params = Object.assign({}, this.detailApiParamSet, this.defaultFilter);
            params.id = this.brandKey;
            EventBus.$emit('changeLoading', true);
            try {
                this.$api.$brand[this.getFunc](params).then(res => res.Data.Result).then(res => {
                    if (res.Info.Type !== 1 || util.isEmpty(res.List)) {
                        this.errorAlert( '데이터를 불러올 수 없습니다.');
                        this.$router.back();
                        return false;
                    }
                    this.brandData = res.List[0];
                    EventBus.$emit("getBrandData",this.brandData);
                    EventBus.$emit('changeLoading', false);
                    this.initTemplateConfig();
                })
            } catch (e) {
                console.log((e));
                EventBus.$emit('changeLoading', false);
            }
        },

        _checkValidator() {
            let validatorArr = Object.keys(this.parsingData);
            return this.$validate(validatorArr).then(success => {
                if(!success) {
                    this.errorAlert('필수데이터를 확인해주세요.')
                    util.Array.each(this.writeLayouts, (layout, index, arr) => {
                        EventBus.$emit(`${layout}Validator`, validatorArr);
                    });
                    return success
                }
                util.Array.each(this.fileInfo, (fileInfo, index, arr) => {
                    if(success && fileInfo.required && util.isEmpty(this[fileInfo.fileName])) {
                        this.errorAlert(fileInfo.validatorMsg)
                        success = false;
                    }
                })
                return success;
            })
        },

        _makeParams () {
            let params = Object.assign({}, this.writeApiParamSet);
            util.Object.each(this.parsingData, (dataKey, paramKey, obj) => {
                if(this.allSetData || this.brandData[paramKey] !== this[dataKey]) {
                    params[paramKey] = this[dataKey];
                }
            })
            if(this.brandData.mb_sex === 1 && params.hasOwnProperty('mb_mat_top')) {
                params.mb_mat_waist = params.mb_mat_top;
                delete params.mb_mat_top;
            }
            if(this.brandData.mb_sex === 1 && params.hasOwnProperty('mb_mat_bottom')) {
                params.mb_mat_thigh = params.mb_mat_bottom;
                delete params.mb_mat_bottom;
            }

            if(this.brandKey !== 0) {
                params[this.keyName] = this.brandKey;
            }
            return params
        },

        async writeBrand() {
            if (this.isRunning) {
                return false;
            }
            this.isRunning = true;
            let validator = await this._checkValidator();
            if(!validator) {
                this.isRunning = false;
                return false;
            }

            EventBus.$emit('changeLoading', true);
            let params = this._makeParams();
            if(this.brandKey != 0){
                params.b_idx = this.brandKey;
            }
            try {
                this.$api.$brand[this.writeFunc](params).then(res => res.Data.Result).then(res => {
                    let type = this.returnWriteType(res.Info.Type);
                    if (type === true) {
                        let key = res.List;
                        if(key.hasOwnProperty(this.keyName)) {
                            key = res.List[this.keyName];
                        }
                        if (this.brandKey !== 0) {
                            key = this.brandKey;
                        }
                        if (!util.isEmpty(this.deleteFiles)) {
                            this.removeFiles(this.deleteFiles);
                        }
                        this.runApiUploadFiles(this.fileInfo, key).then(res => {
                            this.afterFunc(key);
                        })
                        /*if(this.b_lookbook_display == 1){
                            if (!util.isEmpty(this.deleteFiles)) {
                              this.removeFiles(this.deleteFiles);
                            }
                            this.runApiUploadFiles(this.fileInfo, key).then(res => {
                                this.afterFunc(key);
                            })
                        }else {
                            this.afterFunc(key);
                        }*/
                    }else{
                        this.errorAlert(type);
                        this.isRunning = false;
                        EventBus.$emit('changeLoading', false);
                    }
                })
            }catch (e) {
                console.log(e)
                this.isRunning = false;
                EventBus.$emit('changeLoading', false);
            }
        },

        returnWriteType(type) {
            if (type === this.writeSuccessType) {
                return true;
            } else {
                return util.isEmpty(this.writeFailTypes[type]) ? this.writeFailMsg : this.writeFailTypes[type]
            }
        },

        afterFunc() {
            this.isRunning = false;
            EventBus.$emit('changeLoading', false)
            this.createAlert({
                content: '저장하였습니다.',
                hide: () => {
                    if (this.directType === 'back') {
                        this.$router.back();
                        return false;
                    }
                    if (this.directType === 'admin') {
                        this.writeLayouts = [];
                        this.$nextTick(() => {
                            this.initTemplateConfig();
                        })
                        return false;
                    }
                    if (this.directType === 'modal') {
                        this.$modal.hide(this.directUrl);
                        return false;
                    }
                    if (this.directUrl === '') {
                        this.writeLayouts = [];
                        this.getBrand();
                        return false;
                    }
                    EventBus.$emit('changeLoading', false)
                    let url = this.directUrl;
                    this.$router.push(url);
                }
            })
        },
        newDeleteClass() {
            if (!util.isEmpty(this.deleteFunc)) {
                let deleteOptions = {
                    func: this.$api.$brand[this.deleteFunc],
                    apiParamSet: this.deleteApiParamsSet,
                    keyName: this.keyName,
                    successType: this.deleteSuccessType,
                    errorTypes: this.deleteFailTypes,
                    afterFunc: this.deleteAfterFunc,
                }
                this.DeleteClass = new DeleteClass(deleteOptions);
            }
        },

        runDelete() {
            console.log("upadsf")
            EventBus.$emit('changeLoading', true);
            this.DeleteClass.runDelete(this.brandKey);
        },

        deleteAfterFunc() {
            EventBus.$emit('changeLoading', false)
            this.createAlert({
                content: '삭제가 완료되었습니다.',
                hide: () => {
                    this.$router.back();
                }
            })
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
